var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLesionCorporative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 33.629,
    viewBox: "0 0 34 33.629",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11338",
    "data-name": "Group 11338",
    transform: "translate(14602.667 18769.967)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2177",
    "data-name": "Rectangle 2177",
    width: 34,
    height: 33.63,
    rx: 16.815,
    transform: "translate(-14602.667 -18769.967)",
    fill: "#394F65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7058",
    "data-name": "Path 7058",
    d: "M9.056,10.913a1.852,1.852,0,0,1-1.313-.544l-7.2-7.2A1.857,1.857,0,0,1,3.171.544L9.056,6.429,14.941.544a1.857,1.857,0,1,1,2.627,2.627l-7.2,7.2A1.852,1.852,0,0,1,9.056,10.913Z",
    transform: "translate(-14590.389 -18745.051) rotate(-90)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLesionCorporative);
export default __webpack_public_path__ + "static/media/arrow-lesion-corporative.632cc4e9eb74027fb68c30d2dd734909.svg";
export { ForwardRef as ReactComponent };